var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / download"),React.createElement("g",{"id":"icons-/-download","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M2,13.9995 L2,22.0005 L22,22.0005 L22,13.9995 L24,13.9995 L24,23.9995 L0,23.9995 L0,13.9995 L2,13.9995 Z M13,0 L12.9998932,14.585 L16.2928932,11.2928932 L17.7071068,12.7071068 L12,18.4142136 L6.29289322,12.7071068 L7.70710678,11.2928932 L10.9998932,14.585 L11,0 L13,0 Z","id":"download","fill":"currentColor"}))]);
}

Download.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Download;

Download.default = Download;
